
export default () => {
  const menu = document.querySelectorAll('.detail-practitionners__menu')

  if (menu === null) return

  const element = document.querySelectorAll('[data-menu-active]')
  if (element === null) return

  const intersectionObserverScroll = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        menu.forEach((item) => {
          if (item.dataset.active === entry.target.id) {
            item.classList.add('active')
          } else {
            item.classList.remove('active')
          }
        })
      }
    })
  }, {
    rootMargin: '-200px',
    threshold: 0.1
  })

  element.forEach(animateElement => intersectionObserverScroll.observe(animateElement))
}
